import { apiPost } from "./api";
import { getRecaptchaToken } from "./recaptcha";

export interface SupplierEnquiry {
  businessType: string;
  location: string;
  catchType: string;
  estimatedVolume: string;
  contactName: string;
  contactEmail: string;
  // Filenames only — see FileUploadField.tsx's comment: no cloud storage
  // exists, so the files themselves are never actually uploaded anywhere.
  gstDocumentName?: string;
  fssaiDocumentName?: string;
  licenceDocumentName?: string;
}

/**
 * Routes a supplier application to Procurement: mints a reCAPTCHA v3 token, then POSTs to
 * the real `/api/public/enquiries/supplier` endpoint (verifies the token, writes the
 * enquiry to Firestore, returns a server-issued reference number). No client-side
 * simulation — see enquiryReference.ts's own comment for why a *client-generated* reference
 * would have been dishonest here.
 */
export async function submitSupplierEnquiry(
  enquiry: SupplierEnquiry,
): Promise<{ ok: true; referenceNumber: string }> {
  const recaptchaToken = await getRecaptchaToken("supplier_enquiry");
  return apiPost<{ ok: true; referenceNumber: string }>("/public/enquiries/supplier", {
    ...enquiry,
    recaptchaToken,
  });
}
